import { render, staticRenderFns } from "./DataTableDateFilter.vue?vue&type=template&id=6f55c5f2&scoped=true&"
import script from "./DataTableDateFilter.vue?vue&type=script&lang=js&"
export * from "./DataTableDateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55c5f2",
  null
  
)

export default component.exports